import { render, staticRenderFns } from "./pass_fail_counts.vue?vue&type=template&id=24da0249&scoped=true&"
import script from "./pass_fail_counts.vue?vue&type=script&lang=ts&"
export * from "./pass_fail_counts.vue?vue&type=script&lang=ts&"
import style0 from "./pass_fail_counts.vue?vue&type=style&index=0&id=24da0249&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da0249",
  null
  
)

export default component.exports